import { forwardRef } from 'react';
import { Checkbox, Input, useBaseSelectContext } from '~/components/granular';
import { useFormatMessage } from '~/intl';

export const SearchInput = forwardRef<
  HTMLInputElement,
  {
    withSelectAll?: boolean;
    onSelectAll?: () => void;
    isChecked?: boolean;
    itemsCount?: number;
    autoFocus?: boolean;
  }
>(({ isChecked = false, itemsCount, withSelectAll = false, autoFocus, onSelectAll }, forwardedRef) => {
  const formatMessage = useFormatMessage();
  const { searchTerm, searchPlaceholder, handleSearchChange, loading, resetSearchTerm } = useBaseSelectContext();

  return (
    <div className="w-full border-b border-neutral-200 px-4 py-3">
      <Input
        autoComplete="off"
        autoFocus={autoFocus}
        clearable
        height="small"
        leftIcon="SearchIcon"
        onChange={handleSearchChange}
        onClear={resetSearchTerm}
        placeholder={searchPlaceholder}
        ref={forwardedRef}
        role="searchbox"
        value={searchTerm}
      />

      {!loading && withSelectAll && (
        <Checkbox
          checked={isChecked}
          className="overflow-hidden pt-3 whitespace-nowrap"
          id="select-all"
          label={formatMessage({ id: 'common.selectAll' }, { count: itemsCount })}
          name="select-all"
          onClick={onSelectAll}
        />
      )}
    </div>
  );
});
